import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=5d152c65&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=5d152c65&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d152c65",
  null
  
)

export default component.exports